import type { Effect, Reducer, Subscription } from '@umijs/max';
import { getShopOperatorPage } from './service';

type ShopOperatorModelType = {
  namespace: 'shopOperator';
  state: API.ShopOperatorState;
  effects: {
    fetchShopOperatorPageEffect: Effect;
    refreshDataEffect: Effect;
  };
  reducers: {
    setPageData: Reducer<API.ShopOperatorState>;
  };
  subscriptions: {
    setup: Subscription;
  };
};

// 封装通用 effect 创建函数
const createEffect =
  (serviceFunc: any): Effect =>
  function* ({ payload, callback }, { call }) {
    const res = yield call(serviceFunc, payload);
    callback && callback(res);
  };

const ShopOperatorModel: ShopOperatorModelType = {
  namespace: 'shopOperator',

  state: {
    items: [],
    total: 0,
    current: 1,
    pageSize: 20,
  },

  effects: {
    fetchShopOperatorPageEffect: function* ({ payload }, { call, put }) {
      const res = yield call(getShopOperatorPage, payload);
      if (res.code === 0) {
        yield put({
          type: 'setPageData',
          payload: {
            items: res.data.items,
            total: res.data.total,
            current: res.data.current,
            pageSize: res.data.pageSize,
          },
        });
      }
    },

    refreshDataEffect: function* ({ payload }, { call, put }) {
      const res = yield call(getShopOperatorPage, payload);
      if (res.code === 0) {
        yield put({
          type: 'setPageData',
          payload: {
            items: res.data.items,
            total: res.data.total,
            current: res.data.current,
            pageSize: res.data.pageSize,
          },
        });
      }
    },
  },

  reducers: {
    setPageData(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },

  subscriptions: {
    setup({ dispatch, history }) {
      return history.listen(({ pathname }) => {
        if (pathname === '/shopManage/shopOperator') {
          // 页面初始化时不自动加载数据，由组件控制
        }
      });
    },
  },
};

export default ShopOperatorModel;
